var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDueDiligence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.482,
    height: 168.692,
    viewBox: "0 0 181.482 168.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4927",
    "data-name": "Group 4927",
    transform: "translate(-679.518 -1141.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-63",
    transform: "translate(679.518 1141.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8178",
    "data-name": "Path 8178",
    d: "M186.909,157.379c13.222-31.307,14.9-75.552-7.891-103.032-12.57-15.16-32.347-20.2-51.226-21.324-16.922-1.025-35.03-.606-50.4,7.419C51.334,53.993,50.689,86.264,31.173,105.3c-15.736,15.352-22.261,37.229-8.827,66.014s38.38,35.31,62.944,26.1,35.694-11.13,65.247-6.525c13.583,2.119,23.439-8.06,29.4-19.056C182.487,167.127,184.832,162.3,186.909,157.379Z",
    transform: "translate(-15.086 -32.619)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8179",
    "data-name": "Path 8179",
    d: "M186.909,157.379c13.222-31.307,14.9-75.552-7.891-103.032-12.57-15.16-32.347-20.2-51.226-21.324-16.922-1.025-35.03-.606-50.4,7.419C51.334,53.993,50.689,86.264,31.173,105.3c-15.736,15.352-22.261,37.229-8.827,66.014s38.38,35.31,62.944,26.1,35.694-11.13,65.247-6.525c13.583,2.119,23.439-8.06,29.4-19.056C182.487,167.127,184.832,162.3,186.909,157.379Z",
    transform: "translate(-15.086 -32.619)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4624",
    "data-name": "Group 4624",
    transform: "translate(-281.164 1020.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-49",
    transform: "translate(986.535 147.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2795",
    "data-name": "Rectangle 2795",
    width: 129.775,
    height: 115.517,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2796",
    "data-name": "Rectangle 2796",
    width: 129.775,
    height: 18.05,
    transform: "translate(0 0)",
    fill: "#64b5f6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2797",
    "data-name": "Rectangle 2797",
    width: 4.888,
    height: 115.517,
    transform: "translate(124.887 0)",
    fill: "#dbdbdb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2798",
    "data-name": "Rectangle 2798",
    width: 4.888,
    height: 22.295,
    transform: "translate(124.887 17.365)",
    fill: "#949494",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2799",
    "data-name": "Rectangle 2799",
    width: 129.775,
    height: 8.773,
    transform: "translate(0 0)",
    fill: "#dbdbdb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2800",
    "data-name": "Rectangle 2800",
    width: 51.18,
    height: 3.653,
    transform: "translate(6.581 2.562)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1193",
    "data-name": "Line 1193",
    x2: 4.492,
    transform: "translate(122.114 2.732)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1194",
    "data-name": "Line 1194",
    x2: 4.492,
    transform: "translate(122.114 4.631)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1195",
    "data-name": "Line 1195",
    x2: 4.492,
    transform: "translate(122.114 6.529)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2803",
    "data-name": "Rectangle 2803",
    width: 38.327,
    height: 5.927,
    transform: "translate(11.309 59.027)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2804",
    "data-name": "Rectangle 2804",
    width: 38.327,
    height: 5.927,
    transform: "translate(58.106 59.027)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2805",
    "data-name": "Rectangle 2805",
    width: 64.584,
    height: 5.927,
    transform: "translate(11.309 70.676)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2806",
    "data-name": "Rectangle 2806",
    width: 64.584,
    height: 5.927,
    transform: "translate(11.309 81.898)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1196",
    "data-name": "Line 1196",
    x2: 5.145,
    transform: "translate(56.11 50.98)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1197",
    "data-name": "Line 1197",
    x2: 16.722,
    transform: "translate(37.072 50.98)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1198",
    "data-name": "Line 1198",
    x2: 5.145,
    transform: "translate(29.611 50.98)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1199",
    "data-name": "Line 1199",
    x2: 98.1,
    transform: "translate(11.006 98.661)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2815",
    "data-name": "Rectangle 2815",
    width: 38.327,
    height: 5.927,
    transform: "translate(11.309 26.097)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2816",
    "data-name": "Rectangle 2816",
    width: 38.327,
    height: 5.927,
    transform: "translate(58.106 26.097)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2817",
    "data-name": "Rectangle 2817",
    width: 77.432,
    height: 5.927,
    transform: "translate(11.309 36.388)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDueDiligence);
export default __webpack_public_path__ + "static/media/noDueDiligence.a499452c220572ce9f6a5d7111b097ac.svg";
export { ForwardRef as ReactComponent };